import { connect } from 'react-redux';
import { has, filter, map } from 'lodash';
import APISourceConfiguration from './APISourceConfiguration';

const mapStateToProps = (state, ownProps) => {
  const {
    entities: { dataMaps },
  } = state;
  const { config } = ownProps;
  const dataMapsInUse = map(
    filter(config['rest.iterations'], {
      'iteration.type': 'data.map.key.queue',
    }),
    (iteration) => {
      const dataMapId = iteration['map.id'];

      return has(dataMaps, dataMapId) ? dataMaps[dataMapId].name : dataMapId;
    },
  );

  return {
    dataMapsInUse,
  };
};

export default connect(mapStateToProps, {})(APISourceConfiguration);
